import _ from 'underscore';

export const projectionGridEnableWithSelection = definePlugin => definePlugin('projectionGridEnableWithSelection', [
  'gridView',
], (gridView) => {
  gridView.on('didUpdate', () => {
    const selectedItems = gridView.selectedItems();
    if (!_.isEmpty(selectedItems)) {
      gridView.trigger('didSelect', gridView.selectedKeys());
    }
  });
});
